import apiFetch from '../apiFetch'

export default function (organizedUnitId, token) {
  return apiFetch({ endPoint: `FaqSection/Combo/${organizedUnitId}`, method: 'GET', body: null, token: token })
}
